var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEvent = function SvgIconEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.5V25.5H31V5.5H3ZM1 2.5C0.447715 2.5 0 2.94772 0 3.5V27.5C0 28.0523 0.447716 28.5 1 28.5H33C33.5523 28.5 34 28.0523 34 27.5V3.5C34 2.94772 33.5523 2.5 33 2.5H1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.82843 0 9.5 0.671573 9.5 1.5V6.5C9.5 7.32843 8.82843 8 8 8C7.17157 8 6.5 7.32843 6.5 6.5V1.5C6.5 0.671573 7.17157 0 8 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0C26.8284 0 27.5 0.671573 27.5 1.5V6.5C27.5 7.32843 26.8284 8 26 8C25.1716 8 24.5 7.32843 24.5 6.5V1.5C24.5 0.671573 25.1716 0 26 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.6167L16.0333 21.7367C12.6 18.6234 10.3333 16.57 10.3333 14.05C10.3333 11.9967 11.9467 10.3834 14 10.3834C15.16 10.3834 16.2733 10.9234 17 11.7767C17.7267 10.9234 18.84 10.3834 20 10.3834C22.0533 10.3834 23.6667 11.9967 23.6667 14.05C23.6667 16.57 21.4 18.6234 17.9667 21.7434L17 22.6167Z"
  })));
};
export default SvgIconEvent;